import React from "react"
import { ContentHomePageHeading } from "./Content/ContentHomePageHeading"
import { ContentHomePageCategories } from "./Content/ContentHomePageCategories"
import { ContentHomePageTechStack } from "./Content/ContentHomePageTechStack"
import { translation } from "../../helper/translation"


export const PartialHomePage = () => {
    return(
        <React.Fragment>
            <ContentHomePageHeading breadcrumb={translation("home")}/>
            <ContentHomePageCategories />
            <ContentHomePageTechStack />
        </React.Fragment>
    )
}